import { motion } from 'framer-motion';
import React from 'react';

interface AddFeedbackButtonProps {
  onClick: () => void;
}

export const AddFeedbackButton: React.FC<AddFeedbackButtonProps> = ({
  onClick,
}) => {
  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.5 }}
      onClick={onClick}
      className="group relative inline-flex items-center -top-3 justify-center  px-2 sm:px-6 py-2 sm:py-3
bg-gradient-to-r from-purple-600 to-blue-500 text-white 
text-xs sm:text-sm font-medium 
rounded-full overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 w-full sm:w-auto min-w-[120px] sm:min-w-[160px]"
    >
      <span className="relative z-10 whitespace-nowrap">Feedback</span>
      <div
        className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-600 
                  opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      />
    </motion.button>
  );
};
